export { Center } from "@mantine/core";
export type { CenterProps } from "@mantine/core";
